import { useUser } from "@/context/useUser";
import { getAccessToken } from "@/lib/storeManager";
import { Navigate, Outlet } from "react-router-dom";
import ipoNavigationRoutes from "../../utils/navigationRoutes";

const IPOProtectedRouter = () => {
  const { isAuthenticated } = useUser();
  const isLoggedIn = getAccessToken() !== null;
  console.log("isAuthenticated", isAuthenticated);
  return isAuthenticated || isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to={ipoNavigationRoutes.IPO_HOME} />
  );
};

export default IPOProtectedRouter;
